import React from "react";
import { SelectDropdown } from "@cadmakers-ui/core";
import { FormGroup, Label, FormText } from "reactstrap";
import { FeedbackSize } from "../../../Constants/feedbackEnums";
import ElementSpacer from "../../../../Layout/Components/ElementSpacer";

type Props = {
  options: FeedbackSize[];
  value?: FeedbackSize;
  onSelect: (selected?: FeedbackSize) => void;
};

type State = {
  isOpen: boolean;
};

export class FeedbackSizeDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  onToggle = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  onChange = (newvalue: any) => {
    this.props.onSelect(newvalue.label);
  };

  getSizeoptions = () => {
    const options: any = [];
    this.props.options.forEach(option => {
      options.push({ value: option, label: option });
    });
    return options;
  };

  render() {
    const styles: React.CSSProperties = {
      backgroundColor: "white",
      color: "black",
      opacity: "initial"
    };

    return (
      <FormGroup>
        <Label for="sizes">
          <ElementSpacer spacing=".25rem">Feature Size</ElementSpacer>
        </Label>
        <SelectDropdown
          options={this.getSizeoptions()}
          value={
            this.props.value
              ? { value: this.props.value, label: this.props.value }
              : this.props.value
          }
          onChange={newvalue => this.onChange(newvalue)}
        />
        <FormText>The size reflects the complexity of the feature request.</FormText>
      </FormGroup>
    );
  }
}
